/* =========================================================================
   Salwar Mahal — swipeable product-card gallery (Kalki-style).

   Markup is in snippets/card-product.liquid; styling in assets/quick-add.css.
   The HEAVY LIFTING is done by NATIVE CSS scroll-snap + real <a> slides:
     - swipe  -> the browser scrolls the .sm-gallery__track (scroll-snap)
     - tap    -> the <a class="sm-gallery__link"> navigates to the product
   So this file does NOT implement swiping or navigation itself. It only:
     1. keeps the dot indicator in sync with the current slide
     2. wires the desktop hover arrows

   Speed (20 Oct 2026): two page-wide listeners instead of setting up every card on load.
   Nothing runs until a shopper swipes or clicks an arrow, so the ~100 cards on the
   homepage cost nothing on page load, and cards added later (infinite scroll, filters)
   work automatically. The first dot is already active in the Liquid markup.
   ========================================================================= */
(function () {
  if (window.__smGalleryInit) return;
  window.__smGalleryInit = true;

  function syncDots(track) {
    var g = track.closest('[data-sm-gallery]');
    if (!g) return;
    var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
    var dots = g.querySelectorAll('.sm-gallery__dot');
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === i);
  }

  // scroll events don't bubble, but a capturing listener on document still sees them
  var pending = null;
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('sm-gallery__track')) return;
      if (pending) cancelAnimationFrame(pending);
      pending = requestAnimationFrame(function () {
        pending = null;
        syncDots(t);
      });
    },
    { capture: true, passive: true }
  );

  // Arrows (desktop only via CSS, but harmless if tapped). stopPropagation so the click
  // doesn't bubble to the card's link overlay and navigate away.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.sm-gallery__arrow');
      if (!btn) return;
      var g = btn.closest('[data-sm-gallery]');
      var track = g && g.querySelector('.sm-gallery__track');
      if (!track) return;
      e.preventDefault();
      e.stopPropagation();
      var dir = btn.classList.contains('sm-gallery__arrow--prev') ? -1 : 1;
      track.scrollBy({ left: dir * (track.clientWidth || 1), behavior: 'smooth' });
    },
    true
  );
})();
